// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__1t-CB","success":"AnswerItem_success__23_mC","error":"AnswerItem_error__3dooB"};